import { j as t } from "../../../../jsx-runtime.BREq8dyb.js";
import { Skeleton as a } from "@mui/joy";
import { lazy as e, forwardRef as s, Suspense as i } from "react";
const m = e(() => import("./components/SlateEditor/SlateEditor.js")), f = s((r, o) => /* @__PURE__ */ t.jsx(i, { fallback: /* @__PURE__ */ t.jsx(a, { height: 24, variant: "rectangular", width: "100%" }), children: /* @__PURE__ */ t.jsx(m, { ...r, ref: o }) }));
export {
  f as default
};
//# sourceMappingURL=FormattedInput.js.map
